import type { User } from '@supabase/supabase-js';
import { formatUserDisplayName } from './utils';

export function getUserDisplayName(user: User | null): string {
  // Only return the display_name if it exists and is not empty
  const displayName = user?.user_metadata?.display_name;
  if (displayName && displayName.trim() !== '') {
    // Apply proper capitalization to the display name
    return formatUserDisplayName(displayName);
  }

  // No longer fallback to email - encourage users to set their own display name
  return '';
}

export function getUserAvatarUrl(user: User | null): string | null {
  return user?.user_metadata?.avatar_url || null;
}
